import Marquee from "react-fast-marquee";
import { Reveal } from "../Reveal";

const VENDORS = [
  {
    name: "Huntress",
    tag: "Security Platform",
    points: [
      "Managed EDR with a 24/7 human-led SOC",
      "Managed ITDR for Microsoft 365 identities",
      "Managed SIEM — log correlation & retention",
      "Security awareness training & phishing simulations",
    ],
  },
  {
    name: "MSP360",
    tag: "Backup & RMM",
    points: [
      "Immutable, ransomware-proof backup with object lock",
      "Cloud-to-cloud Microsoft 365 backup",
      "Remote monitoring & management of every device",
      "Item-level and point-in-time recovery",
    ],
  },
  {
    name: "Microsoft 365",
    tag: "Productivity Cloud",
    points: [
      "Exchange, Teams, SharePoint & OneDrive",
      "Entra ID & conditional access policies",
      "License management & cost optimization",
      "Migrations, governance & hardening",
    ],
  },
];

export const VendorMarquee = () => (
  <div className="border-y border-white/5 py-6" data-testid="vendor-marquee">
    <Marquee speed={10} gradient={false} pauseOnHover>
      {["Huntress — 24/7 SOC-backed security", "MSP360 — immutable backup & RMM", "Microsoft 365 — productivity cloud"].map(
        (t) => (
          <span key={t} className="text-metallic mx-10 flex items-center gap-10 font-display text-lg font-light uppercase tracking-[0.3em] opacity-75">
            {t} <span className="text-brand/40">◆</span>
          </span>
        )
      )}
    </Marquee>
  </div>
);

export const VendorStack = () => (
  <section className="border-t border-white/5" data-testid="vendor-stack-section">
    <div className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
      <Reveal>
        <p className="eyebrow">Powered by</p>
        <h2 className="mt-6 max-w-4xl font-display text-4xl font-black leading-[1.02] tracking-tighter text-white md:text-6xl lg:text-7xl">
          Enterprise vendors. <span className="text-brand">Small-business focus.</span>
        </h2>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#C9D2DE] md:text-lg">
          We don't build mediocre in-house tools. Sempresera runs your business on the same platforms trusted by
          organizations a hundred times your size — managed by people who know them cold.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 lg:grid-cols-3">
        {VENDORS.map((v, i) => (
          <Reveal key={v.name} delay={i * 0.1}>
            <div className="glass h-full p-8 transition-all duration-300 hover:-translate-y-1 hover:border-brand/40" data-testid={`vendor-card-${v.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <p className="font-display text-xs font-bold uppercase tracking-[0.3em] text-[#A8B4C2]">{v.tag}</p>
              <h3 className="mt-3 font-display text-3xl font-black tracking-tight text-white">{v.name}</h3>
              <ul className="mt-6 space-y-3">
                {v.points.map((p) => (
                  <li key={p} className="flex gap-3 text-sm leading-relaxed text-[#C9D2DE]">
                    <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-brand" />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
